import poolinterface from "../interfaces/poolinterface";
import poolgroupassignmentinterface from "../interfaces/poolgroupassignmentinterface";

export default {
    async getPoolGroupAssignments(poolGroup, poolGroupAssignmentList) {
        let pools = null;
        let assignedPoolGroups = null;

        await poolinterface.getMacPools(result => {
            pools = result;
        });

        await poolgroupassignmentinterface.getPoolGroupAssignmentsForPoolGroup(poolGroup.poolGroupId, assignments => {
            assignedPoolGroups = assignments;
        });

        let poolGroupAssignments = [];

        if (pools != null) {
            for (const pool of pools) {
                let poolGroupAssignment = {
                    poolGroupAssignmentId: null,
                    poolAssigned: false,
                    pool: {
                        poolId: pool.poolId,
                        name: pool.name,
                        description: pool.description,
                        oui: pool.oui,
                        startMac: pool.startMac,
                        endMac: pool.endMac,
                        isActive: pool.isActive
                    },
                    poolGroup: {
                        poolGroupId: poolGroup.poolGroupId,
                        name: poolGroup.name,
                        description: poolGroup.description
                    }
                };

                if (assignedPoolGroups != null) {
                    assignedPoolGroups.forEach(function (assignedPoolGroup) {
                        if (assignedPoolGroup.pool != null && assignedPoolGroup.pool.poolId === pool.poolId) {
                            poolGroupAssignment.poolGroupAssignmentId = assignedPoolGroup.poolGroupAssignmentId;
                            poolGroupAssignment.poolAssigned = true;
                        }
                    });
                }

                poolGroupAssignments.push(poolGroupAssignment);
            }
        }
        poolGroupAssignmentList(poolGroupAssignments);
    }
}


// WEBPACK FOOTER //
// ./src/managers/poolgroupmanager.js